var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-brand-darker container-padding-x"},[_c('div',{staticClass:"max-w-5xl mx-auto py-24 text-center"},[_vm._t("body")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }